'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.ZRUSENA = exports.REALIZOVANA = exports.PLANOVANA = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Stav vratky.
 */

var PLANOVANA = exports.PLANOVANA = 'PLANOVANA';

var REALIZOVANA = exports.REALIZOVANA = 'REALIZOVANA';

var ZRUSENA = exports.ZRUSENA = 'ZRUSENA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [PLANOVANA, REALIZOVANA, ZRUSENA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, PLANOVANA, { caption: '' }), (0, _defineProperty3.default)(_params, REALIZOVANA, { caption: '' }), (0, _defineProperty3.default)(_params, ZRUSENA, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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